import { ItemFinderListView } from "../../ItemFinderListView";
import { ListColumn } from "../ListColumn";
import { ListView } from "../ListView";

export class WebTraderListView extends ItemFinderListView{

    constructor(items: any,  columns: ListColumn[]) {
        super(items,columns,columns);
    }

}